var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.videoUrl.indexOf("vimeo") > 0
    ? _c("div", { staticClass: "video-wrapper", class: { hide: !_vm.ready } }, [
        _c(
          "div",
          { staticClass: "plyr__video-embed player", attrs: { id: "player" } },
          [
            _c("iframe", {
              attrs: {
                src:
                  "https://player.vimeo.com/video/" +
                  _vm.vimeoId +
                  "?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media",
                allowfullscreen: "",
                allowtransparency: "",
                allow: "autoplay"
              }
            })
          ]
        )
      ])
    : _vm.videoUrl.indexOf("youtu") > 0
    ? _c("div", { staticClass: "video-wrapper", class: { hide: !_vm.ready } }, [
        _c(
          "div",
          { staticClass: "plyr__video-embed player", attrs: { id: "player" } },
          [
            _c("iframe", {
              attrs: {
                src:
                  "https://www.youtube.com/embed/" +
                  _vm.youtubeId +
                  "?origin=https://plyr.io&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1",
                allowfullscreen: "",
                allowtransparency: "",
                allow: "autoplay"
              }
            })
          ]
        )
      ])
    : _vm.videoUrl.indexOf(".mp4") > 0
    ? _c("div", { staticClass: "video-wrapper", class: { hide: !_vm.ready } }, [
        _c(
          "video",
          {
            staticClass: "player",
            attrs: { id: "player", playsinline: "", controls: "" }
          },
          [_c("source", { attrs: { src: _vm.videoUrl, type: "video/mp4" } })]
        )
      ])
    : _c("iframe", {
        staticClass: "w-full h-full",
        attrs: { src: "" + _vm.videoUrl }
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }